<div [formGroup]="formSearch">
  <div class="mb-3 flex justify-between items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Codigo tg</mat-label>
      <input matInput formControlName="codigoTg" />
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-5/12"
      appearance="outline"
    >
      <mat-label>Cliente</mat-label>
      <input matInput formControlName="nomeCliente" />
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Consultor</mat-label>
      <input matInput formControlName="nomeConsultor" />
    </mat-form-field>
  </div>

  <div class="mb-3 flex justify-between items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-6/12"
      appearance="outline"
    >
      <mat-label>Tipo</mat-label>
      <mat-select formControlName="tipoId">
        @for (tipo of listTipo; track tipo.id) {
          <mat-option [value]="tipo.id">{{ tipo.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-6/12"
      appearance="outline"
    >
      <mat-label>Desfecho</mat-label>
      <mat-select formControlName="desfechoId">
        @for (desfecho of listDesfecho; track desfecho.id) {
          <mat-option [value]="desfecho.id">{{ desfecho.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="mb-3 flex items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Enviado de</mat-label>
      <input
        matInput
        [matDatepicker]="dateEnvioStart"
        (focus)="openDatepicker('dateEnvioStart')"
        formControlName="dateEnvioStart"
        readonly
        [max]="formSearch.get('dateEnvioEnd')!.value"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="dateEnvioStart"
      ></mat-datepicker-toggle>
      <mat-datepicker #dateEnvioStart></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Enviado ate</mat-label>
      <input
        matInput
        [matDatepicker]="dateEnvioEnd"
        (focus)="openDatepicker('dateEnvioEnd')"
        formControlName="dateEnvioEnd"
        readonly
        [min]="formSearch.get('dateEnvioStart')!.value"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="dateEnvioEnd"
      ></mat-datepicker-toggle>
      <mat-datepicker #dateEnvioEnd></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Retornado de</mat-label>
      <input
        matInput
        [matDatepicker]="dateRetornoStart"
        (focus)="openDatepicker('dateRetornoStart')"
        formControlName="dateRetornoStart"
        readonly
        [max]="formSearch.get('dateRetornoEnd')!.value"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="dateRetornoStart"
      ></mat-datepicker-toggle>
      <mat-datepicker #dateRetornoStart></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Retornado ate</mat-label>
      <input
        matInput
        [matDatepicker]="dateRetornoEnd"
        (focus)="openDatepicker('dateRetornoEnd')"
        formControlName="dateRetornoEnd"
        readonly
        [min]="formSearch.get('dateRetornoStart')!.value"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="dateRetornoEnd"
      ></mat-datepicker-toggle>
      <mat-datepicker #dateRetornoEnd></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="mb-3 flex justify-end items-center gap-2">
    <button
      class="btn-icon"
      (click)="sendSearch(false)"
      [matTooltip]="'Limpar Pesquisar'"
    >
      <mat-icon>replay</mat-icon>
    </button>
    <button class="btn-icon" (click)="sendSearch()" [matTooltip]="'Pesquisa'">
      <mat-icon>search</mat-icon>
    </button>
  </div>
</div>
